import { NextSeo } from 'next-seo';
import React from 'react';

import { CVReviewModule } from '@/modules';

import { MetaCVReview } from '@/data/meta';

const CVReviewRedirect = () => (
  <>
    <NextSeo
      title={MetaCVReview.title}
      description={MetaCVReview.description}
      additionalMetaTags={[
        {
          name: 'keywords',
          content: MetaCVReview.keywords.join(','),
        },
      ]}
      openGraph={{
        type: 'website',
        url: MetaCVReview.url,
        description: MetaCVReview.description,
        images: [
          {
            url: '/thumb_hd.png',
            width: 1280,
            height: 720,
            alt: 'Kerjago Cover HD',
            type: 'image/png',
          },
          {
            url: '/thumb_square.png',
            width: 500,
            height: 500,
            alt: 'Kerjago Cover Square',
            type: 'image/png',
          },
        ],
      }}
    />
    <CVReviewModule />
  </>
);

export default CVReviewRedirect;
